
import API from "../../API/api";

export const GettingDailyProblems = async () => {
  try {
    const response = await API.get("/problems/daily/today");
    return {data:response.data, message : "Found"};
  } catch (err) {
    if (err.response && err.response.status === 404) {
      return { message: "NotFound" };
    }
    console.error("Error getting Daily Problems:", err);
    return { message: "Something went wrong while fetching daily problem" };
  }
};
